import { render, staticRenderFns } from "./MegaMenu.vue?vue&type=template&id=101aef0d"
import script from "./MegaMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./MegaMenu.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports